(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var COLORS = ['#2A324B', '#414C6B', '#D7DCE5', '#8FA0C7', '#FFFFFF'];
  var canvas, ctx, particles = [], rafId = null;

  function ensureCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:9999;';
    document.body.appendChild(canvas);
    resize();
    window.addEventListener('resize', resize);
  }

  function resize() {
    if (!canvas) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function burst(originX, originY) {
    ensureCanvas();
    ctx = canvas.getContext('2d');
    var count = 26;
    for (var i = 0; i < count; i++) {
      var angle = (Math.PI * 2 * i) / count + Math.random() * 0.5;
      var speed = 3 + Math.random() * 5;
      particles.push({
        x: originX,
        y: originY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 3,
        size: 5 + Math.random() * 5,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        rotation: Math.random() * Math.PI,
        rotationSpeed: (Math.random() - 0.5) * 0.3,
        life: 1,
      });
    }
    if (!rafId) rafId = requestAnimationFrame(tick);
  }

  function tick() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var alive = false;
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      if (p.life <= 0) continue;
      p.vy += 0.15;
      p.x += p.vx;
      p.y += p.vy;
      p.rotation += p.rotationSpeed;
      p.life -= 0.014;
      if (p.life > 0) {
        alive = true;
        ctx.save();
        ctx.globalAlpha = Math.max(p.life, 0);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      }
    }
    if (alive) {
      rafId = requestAnimationFrame(tick);
    } else {
      particles = [];
      rafId = null;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }

  function bounceCartIcon() {
    var iconBubble = document.querySelector('.cart-count-bubble');
    var wrapper = iconBubble ? iconBubble.closest('a, button, .header__icon') : null;
    var target = wrapper || iconBubble;
    if (!target) return;
    target.classList.add('pm-cart-bounce');
    setTimeout(function () {
      target.classList.remove('pm-cart-bounce');
    }, 350);
  }

  function originNearCartIcon() {
    var icon = document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href*="/cart"]');
    if (icon) {
      var rect = icon.getBoundingClientRect();
      if (rect.width) {
        return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
      }
    }
    return { x: window.innerWidth / 2, y: window.innerHeight * 0.35 };
  }

  function onCartUpdate() {
    var origin = originNearCartIcon();
    burst(origin.x, origin.y);
    bounceCartIcon();
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
